
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'

export default defineComponent({
    components: { DataTable, Column, Dropdown },
    emits: ['indicatorsValidationChanged'],
    props: { documentDataProp: { type: Object as any, required: false } },
    computed: {
        indicatorsInvalid() {
            if ((this.documentDataProp.indicators.length == 0 && this.documentDataProp.datasetLabel != '') || this.indicatorsContainEmptyFields) {
                return true
            } else return false
        },
        indicatorsContainEmptyFields() {
            let value = false
            this.documentDataProp.indicators.forEach((field) => {
                if (!field.name || !field.label || field.label === '') {
                    value = true
                } else value = false
            })
            return value
        }
    },
    data() {
        return {
            styleDescriptor,
            documentData: {} as any
        }
    },
    created() {
        this.documentData = this.documentDataProp
        this.$emit('indicatorsValidationChanged', 'indicatorsInvalid', this.indicatorsInvalid)
    },
    watch: {
        documentDataProp() {
            this.documentData = this.documentDataProp
        },
        indicatorsInvalid() {
            this.$emit('indicatorsValidationChanged', 'indicatorsInvalid', this.indicatorsInvalid)
        }
    },
    methods: {
        addIndicatorRow() {
            this.documentData.indicators.push({ name: null, label: null })
        },
        deleteIndicatorRow(eventData) {
            this.documentData.indicators.splice(eventData.index, 1)
        }
    }
})
